import React from 'react';
import { withStyles } from '@material-ui/core';
import { colors } from '@peachjar/components';

const { gold } = colors; 

const styles = theme => ({
  circleList: {
    counterReset: 'item',
    listStyleType: 'none',
    '&>li:before': {
      content: 'counter(item) "  "',
      counterIncrement: 'item',
      position: 'relative',
      width: 24,
      justifyContent: 'center',
      height: 24,
      border: `solid 2px ${gold}`,
      borderRadius: '50%',
      fontSize: 13,
      display: 'flex',
      left: '-3rem',
      top: '1.5rem',
    },
  },
});

const CircleList = ({ classes, children }) => (
  <ol className={classes.circleList}>{children}</ol>
);

export default withStyles(styles)(CircleList);



// WEBPACK FOOTER //
// ./src/Onboarding/Setup/go-live/elements/CircleList.jsx